import { render, staticRenderFns } from "./Weightrecording.vue?vue&type=template&id=43ae3d0f&scoped=true&"
import script from "./Weightrecording.vue?vue&type=script&lang=js&"
export * from "./Weightrecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae3d0f",
  null
  
)

export default component.exports